import { SectionHeading } from "components/misc/Headings";

const { default: tw } = require("twin.macro");

export const HeroContainer = tw.div`tw-absolute tw-top-0 tw-left-0 tw-w-screen tw-h-screen -tw-ml-8 -tw-mt-32 -tw-z-50`;
export const Hero = tw.div`tw-bg-primary-800 tw-w-full tw-h-[600px] sm:tw-h-[550px]`;
export const Heading = tw(
  SectionHeading,
)`tw-w-full tw-text-left tw-mb-8 tw-text-gray-100`;
export const PillSlider = tw.div`tw-overflow-visible sm:tw-overflow-hidden tw-whitespace-nowrap tw-overflow-x-scroll tw-pb-2`;
export const Pill = tw.div`tw-inline-flex tw-text-gray-800 tw-pl-4 tw-pr-4 tw-pb-2 tw-pt-2 tw-rounded tw-font-bold tw-mt-2 tw-mr-3`;
export const InformationContainer = tw.div`tw-relative tw-w-full tw-bg-gray-100 tw-p-12 tw-mt-12 tw-rounded-xl tw-drop-shadow-2xl tw-border-gray-900 tw-border-2`;
